import moment, {Moment} from 'moment'

export const isPast = (currentDate: Moment) => currentDate.valueOf() < moment().valueOf()

export const isDateBefore = (currentDate: Moment) => moment(currentDate).isBefore(moment(), 'day')
